import React from 'react';
import ReactDOM from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import "antd/dist/antd.css";
import {applyMiddleware, compose, combineReducers, createStore} from 'redux';
import { Provider } from 'react-redux';
import { HashRouter, BrowserRouter } from 'react-router-dom';

import reducer from './reducers';
import SettingsActions from './redux/SettingsActions';
import ApiUtils from './liferay/ApiUtils';
import i18n from './i18n';

//Соединение с REST сервисами
import { getPanel } from './utils/panelUtils';

import '../css/services.css';
import '../css/table.css';
import '../css/white.css';
import '../css/reset.css';
import '../css/documents.css';
import '../css/common.css';
import '../css/catalog.css';
import '../css/asset.css';
import '../css/csi.css';
import '../css/vowl.css';
import '../css/toolstyle.css';
import '../css/models.css';
import '../css/bootstrap.css';

global._babelPolyfill = false;

/** 
* Общая схема использования компонент:
* 1. Главная компонента App, которая определяет store и router для основного окна
* 2. Основное окно - панель ADMSPanel, которая содержит верхнее меню, содержимое и нижний статус бар
* 3. Содержимое определено в компонентах из каталога components. MainComponent - для отображения и редактирования справочников.
* 4. MainComponent используется представления (views) для отобрадения списка значений или формы создания/редактирования
*/
const middlewares = [];
if (process.env.NODE_ENV === 'development') {
	const {logger} = require('redux-logger');
	middlewares.push(logger);
}
middlewares.push(thunkMiddleware);
const store = composeWithDevTools(applyMiddleware(...middlewares))(createStore)(reducer);

const PanelComponent = getPanel();

const Application = () => {
	if (ApiUtils.isLifeRayPresent()){
		console.log("Application", ApiUtils.getLanguage(), ApiUtils.isSignedIn());
		store.dispatch(SettingsActions.LANG(ApiUtils.getLanguage()));
		store.dispatch(SettingsActions.SIGNED(ApiUtils.isSignedIn()));
		i18n.changeLanguage(ApiUtils.getLanguage());
	}
	return (
		<Provider store={store}>
			<HashRouter>
					<PanelComponent />
			</HashRouter>
		</Provider>
	)
}

ReactDOM.render(<Application />, document.getElementById('catalog_app'));